import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    GetTotalCommissionInfo({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get('/Receipts/GetTotalCommissionInfo', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    GetDistributionWithdrawApiModelListSearch({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get('/Receipts/DistributionWithdrawListSearch', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    GetReceiptsApiModelListSearch({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get('/Receipts/ReceiptsApiModelListSearch', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    GetReceiptsApiModelByReceiptsId({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.get('/Receipts/GetReceiptsApiModelByReceiptsId', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    AddDistributionWithdraw({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/Receipts/AddDistributionWithdrawVue', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    AddReceipts({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.post('/Receipts/AddReceiptsVue', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    EditReceipts({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.post('/Receipts/EditReceiptsVue', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });
    },
    EditDefaultBank({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.post('/Receipts/EditDefaultBankVue', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });

    },
    DelReceipts({ commit }, payload) {
        return new Promise((resolve, reject) => {
            api.post('/Receipts/DelReceiptsVue', payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        });

    }
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
